export type ReactiveFormHostDiagnosticLevel = 'info' | 'warn' | 'error';

export type ReactiveFormHostDiagnosticContextValue = string | number | boolean | null;

export type ReactiveFormHostDiagnosticContext = Readonly<Record<string, ReactiveFormHostDiagnosticContextValue>>;

export interface ReactiveFormHostDiagnosticEntry {
    readonly level: ReactiveFormHostDiagnosticLevel;
    readonly code: string;
    readonly message: string;
    readonly context?: ReactiveFormHostDiagnosticContext | undefined;
}

export interface ReactiveFormHostDiagnosticOptions {
    readonly code: string;
    readonly message: string;
    readonly context?: ReactiveFormHostDiagnosticContext | undefined;
}

/** Collects lightweight host diagnostics without depending on application services. */
export class ReactiveFormHostDiagnostics {
    private entries: ReactiveFormHostDiagnosticEntry[] = [];

    public info(options: ReactiveFormHostDiagnosticOptions): void {
        this.add('info', options);
    }

    public warn(options: ReactiveFormHostDiagnosticOptions): void {
        this.add('warn', options);
    }

    public error(options: ReactiveFormHostDiagnosticOptions): void {
        this.add('error', options);
    }

    public snapshot(): readonly ReactiveFormHostDiagnosticEntry[] {
        return [...this.entries];
    }

    public clear(): void {
        this.entries = [];
    }

    private add(level: ReactiveFormHostDiagnosticLevel, options: ReactiveFormHostDiagnosticOptions): void {
        this.entries = [
            ...this.entries,
            {
                level,
                code: options.code,
                message: options.message,
                context: options.context,
            },
        ];
    }
}
